import React from 'react';
import PropTypes from 'prop-types';

const LastMessage = ({ lastMessage, thread }) => {
  const user = lastMessage?.client || lastMessage?.user;

  const name = [user?.firstName, user?.lastName];

  const lastMassagePreview =
    lastMessage?.messageType === 'attachment'
      ? `${name[0]} sent ${lastMessage.attachment}`
      : lastMessage?.message.split('<br>');

  if (lastMessage) {
    if (lastMessage?.user) {
      return `Tu: ${lastMassagePreview[0]}`;
    }

    if (thread.type === 'group') {
      return (
        <div
          className="chat-contact-content"
          dangerouslySetInnerHTML={{
            __html: `${name[0]}: ${lastMassagePreview}`
          }}
        />
      );
    }

    return lastMassagePreview[0];
  }

  return <div>Saluda a tu nuevo amigo</div>;
};

LastMessage.propTypes = {
  thread: PropTypes.object.isRequired,
  lastMessage: PropTypes.object
};

export default LastMessage;
